import { Helper } from "../helpers/helper";
import { ImisClientContext, ImisResponseItems } from "../models/imis.models";
import { RestUtility } from "./rest.utility";
import { UrlUtility } from "./url.utility";

export class ContextUtility {
    public static getImisClientContext(): ImisClientContext {
        let clientContext = new ImisClientContext();

        let jClientContext = jQuery("#__ClientContext");
        if (jClientContext.length > 0) {
            let clientContextString = jClientContext.val().toString();
            if (clientContextString.length > 0) {
                clientContext = JSON.parse(clientContextString);
            }
        }

        return clientContext;
    }

    public static getSelectedImisId(useUrl = false): string {
        let selectedId = UrlUtility.findUrlParameter("id");
        let clientContext = this.getImisClientContext();
        
        if (!useUrl || Helper.isStringNullOrEmpty(selectedId)) {
            selectedId = clientContext.selectedPartyId;
        }

        return selectedId;
    }

    public static getDateTimeInImisTimezone(localDateTime: Date = new Date()): Date {
        let dateTimeInImisTimezone: Date;

        let localDateTimeOffsetFromUtcHours = localDateTime.getTimezoneOffset() * 60 * 1000;
        let appTimeZoneOffsetHours = this.getImisClientContext().appTimeZoneOffset;

        let totalOffset = localDateTimeOffsetFromUtcHours + appTimeZoneOffsetHours;        
        dateTimeInImisTimezone = new Date(localDateTime.getTime() + totalOffset);
        
        return dateTimeInImisTimezone;
    }

    public static async getImisVersion(): Promise<{ version: string, isCloud: boolean }> {
        let imisVersion = { version: "", isCloud: false };

        let systemParamsResponse = await RestUtility.restApiGetData<ImisResponseItems<any>>("/api/SystemParam?ParameterName=System_Control.Version");
        if (systemParamsResponse != null && systemParamsResponse.Items.length > 0) {
            imisVersion.version = systemParamsResponse.Items[0].ShortValue;
            imisVersion.isCloud = !Helper.isStringNullOrEmpty(imisVersion.version) && imisVersion.version.startsWith("20.3");
        }

        return imisVersion;
    }

}